function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export const methodMemoryCacheMaxEntries = 10000;
export class MethodMemoryCache {
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        // We only cache up to maxEntries, not more
        if (this.cache.size >= this.maxEntries) {
            return;
        }
        this.cache.set(key, value);
    }
    constructor(maxEntries = methodMemoryCacheMaxEntries){
        _define_property(this, "maxEntries", void 0);
        _define_property(this, "cache", new Map());
        this.maxEntries = maxEntries;
    }
}

//# sourceMappingURL=MethodMemoryCache.js.map